// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import AccueilPage from './pages/AccueilPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import ClientDetailPage from './pages/clients/components/ClientDetailPage';
import PersonnelPage from './pages/PersonnelPage';
import VehiculePage from './pages/VehiculePage';
import VentePage from './pages/ventes/VentePage';
import AchatPage from './pages/achats/AchatPage';
import FacturePage from './pages/FacturePage';
import ProfilePage from './pages/ProfilePage';
import FournisseursPage from './pages/FournisseursPage';
import AddFournisseurPage from './components/AddFournisseurPage'; 
import AddVehicule from './components/AddVehicule';
import ChauffeurPage from './pages/ChauffeurPage';
import PermissionPage from './pages/PermissionPage';
import UserPage from './pages/UserPage';
import RoleManagementPage from './pages/settings/RoleManagementPage';
import PermissionManagementPage from './pages/settings/PermissionManagementPage';
import UserManagementPage from './pages/settings/UserManagementPage';
import ClientPage from './pages/clients/ClientPage';
import { DashboardProvider } from './contexts/DashboardContext';

function App() {
  return (
    <DashboardProvider> {/* 🔥 WRAPPER GLOBAL */}
      <Router>
        <Routes>
          {/* Routes publiques */}
          <Route path="/" element={<Navigate to="/accueil" />} />
          <Route path="/accueil" element={<AccueilPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Routes protégées */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <MainLayout><DashboardPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/clients" element={
            <ProtectedRoute>
              <MainLayout><ClientPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/clients/:id" element={
            <ProtectedRoute>
              <MainLayout><ClientDetailPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/personnels" element={
            <ProtectedRoute>
              <MainLayout><PersonnelPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/vehicules" element={
            <ProtectedRoute>
              <MainLayout><VehiculePage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/profile" element={
            <ProtectedRoute>
              <MainLayout><ProfilePage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/vente" element={
            <ProtectedRoute>
              <MainLayout><VentePage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/chauffeur" element={
            <ProtectedRoute>
              <MainLayout><ChauffeurPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/fournisseurs" element={
            <ProtectedRoute>
              <MainLayout><FournisseursPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/fournisseurs/add" element={
            <ProtectedRoute>
              <MainLayout><AddFournisseurPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/vehicules/add" element={
            <ProtectedRoute>
              <MainLayout><AddVehicule /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/achat" element={
            <ProtectedRoute>
              <MainLayout><AchatPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/facture/:id" element={
            <ProtectedRoute>
              <MainLayout><FacturePage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/profile/permissions" element={
            <ProtectedRoute>
              <MainLayout><PermissionPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          {/* Routes du menu Réglage */}
          <Route path="/settings/users" element={
            <ProtectedRoute>
              <MainLayout><UserManagementPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/settings/roles" element={
            <ProtectedRoute>
              <MainLayout><RoleManagementPage /></MainLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/settings/permissions" element={
            <ProtectedRoute>
              <MainLayout><PermissionManagementPage /></MainLayout>
            </ProtectedRoute>
          } />

          {/* Route 404 */}
          <Route path="*" element={
            <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
              <h1 className="text-5xl font-bold text-primary-500 mb-4">404</h1>
              <p className="text-lg text-gray-600 mb-8">Page non trouvée</p>
              <a 
                href="/dashboard" 
                className="text-primary-500 hover:text-primary-700 underline"
              >
                Retour au tableau de bord
              </a>
            </div>
          } />
        </Routes>
      </Router>
    </DashboardProvider>
  );
}

export default App;